import { OfflineDataService } from 'src/packages/mitsBasics';
import { BufferstockModel, StockObjectModel } from '../models';

export class StockWithInventoryService<
  T extends BufferstockModel | StockObjectModel
> extends OfflineDataService<T> {
}
